import React from "react";

const ChartIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="6" y="7" width="4" height="15" fill="currentColor" />
    <rect x="12" y="2" width="4" height="20" fill="currentColor" />
    <rect x="18" width="4" height="22" fill="currentColor" />
    <rect y="13" width="4" height="9" fill="currentColor" />
  </svg>
);

export default ChartIcon;
